// extracted by mini-css-extract-plugin
module.exports = {"container":"policy_info_section_container__3GOZS","title":"policy_info_section_title__2oEkf"};